import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { push } from 'react-router-redux';
import {
  FLAG_MANUAL_VOUCHER_ACTIVITY,
  GET_MANUAL_VOUCHER,
  CLEAR_MANUAL_VOUCHER,
  FLAG_GETTING_MANUAL_VOUCHERS,
  CLEAR_MANUAL_VOUCHERS,
  GET_MANUAL_VOUCHERS,
  FLAG_ORIGINAL_VOUCHER_ACTIVITY,
  GET_ORIGINAL_VOUCHER,
  CLEAR_ORIGINAL_VOUCHER,
} from '../types/accounting';
import { MANUAL_VOUCHER_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_PATCH_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { MANUAL_VOUCHER_PATH } from '../../config/paths';

const flagGettingManualVouchers = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_MANUAL_VOUCHERS,
    payload: flag,
  });

const clearManualVouchers = () => (dispatch) =>
  dispatch({
    type: CLEAR_MANUAL_VOUCHERS,
  });

const flagManualVoucherActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_MANUAL_VOUCHER_ACTIVITY,
    payload: flag,
  });

const flagOriginalVoucherActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ORIGINAL_VOUCHER_ACTIVITY,
    payload: flag,
  });

const clearManualVoucher = () => (dispatch) =>
  dispatch({
    type: CLEAR_MANUAL_VOUCHER,
  });

const clearOriginalVoucher = () => (dispatch) =>
  dispatch({
    type: CLEAR_ORIGINAL_VOUCHER,
  });

const getManualVouchers =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingManualVouchers(true));

      const url = `${MANUAL_VOUCHER_ENDPOINT}?${QueryString.stringify(
        tableFilters,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({ type: GET_MANUAL_VOUCHERS, payload: response });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingManualVouchers(false));
    }
  };

const obtainManualVoucher = async ({ manualVoucherId }) => {
  const url = `${MANUAL_VOUCHER_ENDPOINT}/${manualVoucherId}`;
  const promise = await fetch(url, DEFAULT_GET_CONFIG);
  await isErrorResponse(promise);
  const response = await promise.json();
  return response;
};

const getManualVoucher =
  async ({ manualVoucherId }) =>
  async (dispatch) => {
    try {
      dispatch(flagManualVoucherActivity(true));

      const response = await obtainManualVoucher({ manualVoucherId });

      if (response.previousManualVoucherId) {
        const previousManualVoucher = await obtainManualVoucher({
          manualVoucherId: response.previousManualVoucherId,
        });

        response.previousManualVoucher = previousManualVoucher;
      }

      dispatch({
        type: GET_MANUAL_VOUCHER,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagManualVoucherActivity(false));
    }
  };

const postManualVoucher =
  async ({
    voucherTypeId,
    customerId,
    businessId,
    issueDate,
    paymentType,
    affectedByTaxes,
    currencyCode,
    items,
    description,
    detraction, // percent value
    detractionAmount,
    serviceType,
    installments,
    dueDate,
    totalAmount,
    totalAmountPayable,
    taxes,
    totalAmountWithoutTaxes,
    previousManualVoucherId,
    previousTicketId,
    previousParcelId,
    previousExcessBaggageId,
    reasonType,
  }) =>
  async (dispatch) => {
    try {
      dispatch(flagManualVoucherActivity(true));

      const payload = {
        voucherTypeId,
        customerId,
        businessId,
        issueDate,
        paymentType,
        affectedByTaxes,
        currencyCode,
        items,
        description,
        detraction,
        detractionAmount,
        serviceType,
        installments,
        dueDate,
        totalAmount,
        totalAmountPayable,
        taxes,
        totalAmountWithoutTaxes,
        previousManualVoucherId,
        previousTicketId,
        previousParcelId,
        previousExcessBaggageId,
        reasonType,
      };
      const url = MANUAL_VOUCHER_ENDPOINT;

      const promise = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch(push(`${MANUAL_VOUCHER_PATH}/${response.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagManualVoucherActivity(false));
    }
  };

const putManualVoucher =
  async (
    manualVoucherId,
    {
      voucherTypeId,
      customerId,
      businessId,
      issueDate,
      paymentType,
      affectedByTaxes,
      currencyCode,
      items,
      description,
      detraction, // percent value
      detractionAmount,
      serviceType,
      installments,
      dueDate,
      totalAmount,
      totalAmountPayable,
      taxes,
      totalAmountWithoutTaxes,
      documentSeries,
      documentCode,
      previousManualVoucherId,
      userId,
      createDate,
      previousTicketId,
      previousParcelId,
      previousExcessBaggageId,
      reasonType,
      status,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagManualVoucherActivity(true));

      const payload = {
        voucherTypeId,
        customerId,
        businessId,
        issueDate,
        paymentType,
        affectedByTaxes,
        currencyCode,
        items,
        description,
        detraction, // percent value
        detractionAmount,
        serviceType,
        installments,
        dueDate,
        totalAmount,
        totalAmountPayable,
        taxes,
        totalAmountWithoutTaxes,
        documentSeries,
        documentCode,
        previousManualVoucherId,
        userId,
        createDate,
        id: manualVoucherId,
        previousTicketId,
        previousParcelId,
        previousExcessBaggageId,
        reasonType,
        status,
      };
      const url = `${MANUAL_VOUCHER_ENDPOINT}/${manualVoucherId}`;

      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch(push(`${MANUAL_VOUCHER_PATH}/${response.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagManualVoucherActivity(false));
    }
  };

const getOriginalVoucher =
  async ({ originalVoucherSeries, originalVoucherCorrelative, serviceType }) =>
  async (dispatch) => {
    try {
      dispatch(flagOriginalVoucherActivity(true));

      const payload = {
        documentSeries: originalVoucherSeries,
        documentCode: originalVoucherCorrelative,
        serviceType,
      };
      const url = `${MANUAL_VOUCHER_ENDPOINT}/search-original-voucher?${QueryString.stringify(
        payload,
      )}`;

      const promise = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({
        type: GET_ORIGINAL_VOUCHER,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagOriginalVoucherActivity(false));
    }
  };

const getOriginalVoucherById =
  async ({ id, serviceType }) =>
  async (dispatch) => {
    try {
      dispatch(flagOriginalVoucherActivity(true));

      const payload = {
        serviceType,
      };
      const url = `${MANUAL_VOUCHER_ENDPOINT}/search-original-voucher/${id}?${QueryString.stringify(
        payload,
      )}`;

      const promise = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({
        type: GET_ORIGINAL_VOUCHER,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagOriginalVoucherActivity(false));
    }
  };

const patchApproveManualVoucher = async (id) => async (dispatch) => {
  try {
    dispatch(flagManualVoucherActivity(true));

    const url = `${MANUAL_VOUCHER_ENDPOINT}/${id}/approve`;
    const promise = await fetch(url, {
      ...DEFAULT_PATCH_CONFIG,
    });
    await isErrorResponse(promise, null, dispatch);
    await dispatch(
      getManualVouchers({ query: 'voucherTypeId:83', sort: 'id,desc' }),
    );
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagManualVoucherActivity(false));
  }
};

const patchRejectManualVoucher = async (id) => async (dispatch) => {
  try {
    dispatch(flagManualVoucherActivity(true));

    const url = `${MANUAL_VOUCHER_ENDPOINT}/${id}/reject`;
    const promise = await fetch(url, {
      ...DEFAULT_PATCH_CONFIG,
    });
    await isErrorResponse(promise, null, dispatch);
    await dispatch(
      getManualVouchers({ query: 'voucherTypeId:83', sort: 'id,desc' }),
    );
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagManualVoucherActivity(false));
  }
};

export {
  flagGettingManualVouchers,
  clearManualVouchers,
  getManualVouchers,
  flagManualVoucherActivity,
  getManualVoucher,
  clearManualVoucher,
  postManualVoucher,
  putManualVoucher,
  getOriginalVoucher,
  clearOriginalVoucher,
  patchApproveManualVoucher,
  patchRejectManualVoucher,
  getOriginalVoucherById,
};
